import makeStyles from '@material-ui/styles/makeStyles';
import {
  blackColor,
  hexToRgb,
  whiteColor,
} from 'assets/jss/material-dashboard-pro-react';
import classNames from 'classnames';

import MetricsChart from './MetricsChart';
import UsersChart from './UsersChart';
import DoughnutChart from './DoughnutChart';

const useStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'auto auto',
    gap: '24px',
    marginBottom: '24px',
  },
  mainSection: {
    position: 'relative',
    gridColumn: '1 / 3',
    backgroundColor: whiteColor,
    borderRadius: '6px',
    minHeight: '514px',
    boxShadow: `0 1px 4px rgba(${hexToRgb(blackColor)}, 0.14)`,
    padding: '16px',
  },
  usersChartSection: {
    alignSelf: 'start',
  },
  smallerSection: {
    position: 'relative',
    boxShadow: `0 1px 4px rgba(${hexToRgb(blackColor)}, 0.14)`,
    minHeight: '482px',
    backgroundColor: whiteColor,
    borderRadius: '6px',
    padding: '16px',
  },
});

const Charts = ({
  isLoading,
  metricsStatistics,
  renderMetricsLabels,
  renderMetricsComparisonsLabels,
  usersStatistics,
  renderUsersLabels,
  knowAboutUsStatistics,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.mainSection}>
        <MetricsChart
          isLoading={isLoading}
          statistics={metricsStatistics}
          renderLabels={renderMetricsLabels}
          renderComparisonsLabels={renderMetricsComparisonsLabels}
        />
      </div>
      <div
        className={classNames(
          classes.smallerSection,
          classes.usersChartSection
        )}
      >
        <UsersChart
          isLoading={isLoading}
          statistics={usersStatistics}
          renderLabels={renderUsersLabels}
        />
      </div>
      <div className={classes.smallerSection}>
        <DoughnutChart
          isLoading={isLoading}
          statistics={knowAboutUsStatistics}
        />
      </div>
    </div>
  );
};

export default Charts;
